import HttpService from './http-service';
import { Region } from '@bringg/frontend-utils/dist/common/types';
import { getEnv } from 'mobx-easy';
import { RootEnv } from '../helpers/create-store';
import { ApiVersion, ApiVersionResponse, BaseCustomerExperienceData } from '@bringg/types';

export class CustomerExperienceService {
	public getCustomerExperience(sharedLocationUuid: string): Promise<BaseCustomerExperienceData> {
		return HttpService.get<BaseCustomerExperienceData>(`${this.getBaseUrl()}/${sharedLocationUuid}`);
	}

	public async getApiVersion(sharedLocationUuid: string): Promise<ApiVersionResponse> {
		try {
			const response = await HttpService.get<ApiVersionResponse>(
				`${this.getBaseUrl()}/${sharedLocationUuid}/version`
			);

			if (!response.success) {
				// Temporary before moving all expired pages to V2
				//@ts-ignore
				return { api_version: ApiVersion.V1 };
			}

			return response;
		} catch (e) {
			// Temporary before moving all expired pages to V2
			//@ts-ignore
			return { api_version: ApiVersion.V1 };
		}
	}

	private getBaseUrl() {
		return `${this.config.real_time_url}/cx`;
	}

	private get config(): Region {
		const { regionService } = getEnv<RootEnv>();
		return regionService.getConfigByRegion();
	}
}
